@if (isSubmenuOpen()) {
  <div
    class="small-menu-submenu"
    @smoothShowHideHeight
  >
    <div class="menu-name">
      {{ menuWithSubMenu().tag }}
    </div>
    @for (submenu of menuWithSubMenu().submenu; track $index) {
      @switch (submenu.type) {
        @case ('default') {
          @if (isMenuAvailableToCurrentUser(submenu)) {
            <div
              class="submenu-item"
              [class.active]="isSmallSubmenuActive(submenu)"
              (click)="handleDefaultMenuClick(submenu)"
            >
              {{ submenu.tag }}
            </div>
          }
        }
        @case ('sub-menu') {
          <div
            class="submenu-title"
            (click)="handleSubmenuMenuClick(submenu.id, $event)"
          >
            {{ submenu.tag }}
            @if (isSubmenuActive(submenu.id)) {
              <div
                class="submenu-items"
                [style.top.px]="getSubmenuTopPosition(submenu.id)"
              >
                <app-collapsed-submenu-left-menu-item-list
                  [menu]="submenu"
                  [isSubmenuOpen]="isSpecifiedSubmenuOpen(submenu.id)"
                  [parentMenuId]="submenu.id"
                />
              </div>
            }
          </div>
        }
      }
    }
  </div>
}
